import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

// Extensoes
import { init } from '@/lib/i18n'
import VueI18Next from '@panter/vue-i18next'
import { BootstrapVue, BOverlay, IconsPlugin } from 'bootstrap-vue'
import VeeValidate from 'vee-validate'
import VueTheMask from 'vue-the-mask'
import vSelect from 'vue-select'
import VueCurrencyInput from 'vue-currency-input'
import BootstrapTable from 'bootstrap-table/dist/bootstrap-table-vue.esm.js'
import * as VueGoogleMaps from 'vue2-google-maps'
import { mapsApiKey } from '@/lib/config'

import "@/lib/validators";

// js
import './assets/js/inspinia'

// css
import './styles'

// pwa
// import './registerServiceWorker'

const pluginOptions = {
  globalOptions: { currency: 'BRL' }
}

Vue.config.productionTip = false
Vue.use(VueI18Next)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'veeFields'
})
Vue.use(VueTheMask)
Vue.use(VueCurrencyInput, pluginOptions)

Vue.use(VueGoogleMaps, {
  load: {
    key: mapsApiKey(),
    libraries: 'places',
  }
})

Vue.component('vue-select', vSelect)
Vue.component('BootstrapTable', BootstrapTable)
Vue.component('b-overlay', BOverlay)

const app = new Vue({
  router,
  i18n: new VueI18Next(init()),
  store,
  render: h => h(App)
})

app.$mount('#app')
